import type { ReactNode, TableHTMLAttributes } from 'react';

export function Table({
  children,
  ...rest
}: TableHTMLAttributes<HTMLTableElement> & { children: ReactNode }) {
  return (
    <div className="ds-table-wrapper">
      <table className="ds-table" {...rest}>
        {children}
      </table>
    </div>
  );
}
